export default {
  buttons: {
    title1: 'Przytnij',
    title2: 'Zamknij',
  },
};
